import { CheckoutExtensionUI, CustomUpsellExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import UpsellRateType = CustomUpsellExtension.UpsellRateType;

export class CustomUpsellDto {
  constructor() {}

  createCustomUpsellTemplateDTO(template: CustomUpsellExtension.Template | any): CustomUpsellExtension.Template {
    const templateObj: any = {};
    if (template.internalName) {
      templateObj.internalName = template.internalName;
    }
    if (template.title) {
      templateObj.title = template.title;
    }
    if (template.description) {
      templateObj.description = template.description;
    }
    if (template.upsellRateType === UpsellRateType.FIXED) {
      templateObj.upsellRate = template.upsellRate;
      delete templateObj.upsellRatePercentage;
    } else {
      templateObj.upsellRatePercentage = template.upsellRatePercentage;
      delete templateObj.upsellRate;
    }
    if (template.discount != undefined) {
      templateObj.discount = template.discount;
    }

    if (template.prioritizeOrder !== undefined) {
      templateObj.prioritizeOrder = template.prioritizeOrder;
    }
    if (template.customTag !== undefined) {
      templateObj.customTag = template.customTag;
    }
    if (template.autoAdd) {
      const autoAdd = {
        enabled: !!template.autoAdd.enabled,
        mode: template.autoAdd.mode ?? 'once',
        scope: template.autoAdd.scope ?? 'freeOnly',
        persistentCheckbox: template.autoAdd.persistentCheckbox ?? 'disabled',
      };
      templateObj.autoAdd = autoAdd;
      templateObj.markAsChecked = autoAdd.enabled && autoAdd.mode === 'once';
    }

    if (template.tooltipEnabled !== undefined) {
      templateObj.tooltipEnabled = template.tooltipEnabled;
    }
    templateObj.tooltipText = template.tooltipText ?? '';
    templateObj.tooltipTitle = template.tooltipTitle ?? '';
    if (template.restrictionsRules) {
      templateObj.restrictionsRules = template.restrictionsRules;
    }
    templateObj.placementMode = template.placementMode;
    templateObj.upsellRateType = template.upsellRateType;
    templateObj.productImageBase64 = template.productImageBase64 ? template.productImageBase64 : null;
    templateObj.minCartValueThreshold = Number(template.minCartValueThreshold) ? template.minCartValueThreshold : null;
    templateObj.maxCartValueThreshold = Number(template?.maxCartValueThreshold) ? template.maxCartValueThreshold : null;
    templateObj.applyDiscountTo = template.upsellRateType === UpsellRateType.FIXED ? template.applyDiscountTo : null;
    if (template.customProductConfiguration) {
      templateObj.customProductConfiguration = template.customProductConfiguration;
      if (template.upsellRateType === UpsellRateType.FIXED || !templateObj.customProductConfiguration.enabled) {
        templateObj.customProductConfiguration = null;
      }
    }
    if (template.timerConfiguration) {
      templateObj.timerConfiguration = template.timerConfiguration;
    }
    templateObj.keepInCart = template.keepInCart ?? false;
    if (template.trustSignals) {
      templateObj.trustSignals = {
        enabled: !!template.trustSignals.enabled,
        layout: template.trustSignals.layout ?? CustomUpsellExtension.TrustSignalsLayout.VERTICAL,
        backgroundColor: template.trustSignals.backgroundColor ?? 'transparent',
        border: template.trustSignals.border ?? CheckoutExtensionUI.BorderType.NONE,
        cornerRadius: template.trustSignals.cornerRadius ?? CheckoutExtensionUI.CornerRadius.BASE,
        items: (template.trustSignals.items ?? []).map((item: CustomUpsellExtension.TrustSignalItem) => ({
          icon: item?.icon || null,
          richText: item?.richText ?? '',
        })),
      };
    }
    templateObj.infoPopupImage = template.infoPopupImage ? template.infoPopupImage : null;
    if (template.infoPopupImageUrl) {
      templateObj.infoPopupImageUrl = template.infoPopupImageUrl;
    }
    return templateObj;
  }

  createExampleTemplate() {
    return {
      title: 'Priority processing',
      description: 'Get special service for your order',
      upsellRate: '6',
      discount: '20',
    };
  }
}
